export default __webpack_public_path__ + "static/media/mt_portfolio-01.65611cba.png";